export const btn_link={
    payment: "/bank-payment",
    pendingPayment: "/bank-pending-payment",
    refundPayment: "/bank-refund-payment",
    trashPayment: "/bank-trash-payment",
}